import React from "react";

/**
 * WeeklyStatsCard — "Platform Activity" — 2x2 grid of weekly stats.
 *
 * Aggregated platform stats (jobs posted, applications, referrals, hires).
 * No CTAs.
 *
 * Props:
 *   card — feed card object with metadata containing:
 *     jobs_posted, applications_submitted, referrals_made, hires_made
 */
const WeeklyStatsCard = ({ card }) => {
  const meta = card.metadata || {};

  const stats = [
    { label: "Jobs Posted",  value: meta.jobs_posted || 0 },
    { label: "Applications", value: meta.applications_submitted || 0 },
    { label: "Referrals",    value: meta.referrals_made || 0 },
    { label: "Hires Made",   value: meta.hires_made || 0 },
  ];

  // Per PRD §10: if all stats are zero, the card should not render at all.
  const allZero = stats.every((s) => s.value === 0);
  if (allZero) return null;

  return (
    <div style={styles.card}>
      <div style={styles.headerRow}>
        <div style={styles.titleGroup}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3a6ed4" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
          <h6 style={styles.title}>{card.title || "Platform Activity"}</h6>
        </div>
        <span style={styles.subLabel}>This week&apos;s activity</span>
      </div>

      <div style={styles.statsGrid}>
        {stats.map((stat, i) => (
          <div key={i} style={styles.statBox}>
            <span style={styles.statValue}>{formatNumber(stat.value)}</span>
            <span style={styles.statLabel}>{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

function formatNumber(n) {
  return Number(n || 0).toLocaleString();
}

const styles = {
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
    padding: "18px 20px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  titleGroup: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  title: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#0f172a",
    margin: 0,
  },
  subLabel: {
    fontSize: "12px",
    color: "#94a3b8",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
  },
  statBox: {
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    backgroundColor: "#f1f4f9",
    borderRadius: "10px",
  },
  statValue: {
    fontSize: "26px",
    fontWeight: "800",
    color: "#1d3f8f",
  },
  statLabel: {
    fontSize: "13px",
    color: "#64748b",
    marginTop: "2px",
  },
};

export default WeeklyStatsCard;
